<template>
  <el-dialog
    :title="Id ? $t('text.edit_theme') : $t('text.custom_theme')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="800px"
    class="custom-theme"
  >
    <div>
      <el-row :gutter="20">
        <el-form label-position="top" :model="form">
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item :label="$t('text.background_color')">
              <el-color-picker
                v-model="form.contentBg"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.contentBg"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item :label="$t('text.top_navigation_background_color')">
              <el-color-picker
                v-model="form.topNavBg"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.topNavBg"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item :label="$t('text.top_nav_text_color')">
              <el-color-picker
                v-model="form.topNavTextColor"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.topNavTextColor"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item :label="$t('text.top_nav_active_text_color')">
              <el-color-picker
                v-model="form.topNavActiveTextColor"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.topNavActiveTextColor"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item :label="$t('text.sidebar_background_color')">
              <el-color-picker
                v-model="form.leftSidebarBg"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.leftSidebarBg"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item
              :label="$t('text.sidebar_active_block_background_color')"
            >
              <el-color-picker
                v-model="form.sidebarHighlightBg"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.sidebarHighlightBg"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item :label="$t('text.sidebar_text_color')">
              <el-color-picker
                v-model="form.sidebarTextColor"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.sidebarTextColor"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item :label="$t('text.sidbar_active_block_text_color')">
              <el-color-picker
                v-model="form.sidebarActiveTextColor"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.sidebarActiveTextColor"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item :label="$t('text.card_title_background_color')">
              <el-color-picker
                v-model="form.contentCardHeaderBg"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.contentCardHeaderBg"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item :label="$t('text.card_title_text_color')">
              <el-color-picker
                v-model="form.contentCardHeaderTextColor"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.contentCardHeaderTextColor"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item :label="$t('text.card_body_background_color')">
              <el-color-picker
                v-model="form.contentCardBodyBg"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.contentCardBodyBg"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" class="color-picker-item">
            <el-form-item :label="$t('text.card_button_color')">
              <el-color-picker
                v-model="form.commonBtnColor"
                show-alpha
              ></el-color-picker>
              <el-input v-model="form.commonBtnColor"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="submit()"
        :loading="loading"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      Id: 0, //if id===0, it is create new theme, otherwise it is edit theme
      form: {
        title: 'Default',
        topNavBg: '#fff',
        topNavTextColor: '#98C1D9',
        topNavActiveTextColor: '#98C1D9',
        leftSidebarBg: '#3D5A80',
        sidebarHighlightBg: '#98C1D9',
        sidebarTextColor: '#CECECE',
        sidebarActiveTextColor: '#ffffff',
        contentBg: '#293241',
        contentCardHeaderBg: '#98C1D9',
        contentCardHeaderTextColor: '#ffffff',
        contentCardBodyBg: '#ffffff',
        commonBtnColor: '#3d5a80'
      }
    }
  },
  methods: {
    openDialog(item = null) {
      this.dialogVisible = true
      if (item) {
        this.Id = item.id
        this.form = JSON.parse(JSON.stringify(item))
        return
      }
      this.form = JSON.parse(JSON.stringify(this.$parent.selectedColorObj))
    },
    closeDialog() {
      this.Id = 0
      this.dialogVisible = false
    },
    submit() {
      if (this.Id) {
        this.save(this.form.title, null)
        return false
      }
      let vm = this
      this.$prompt('', this.$t('text.please_enter_theme_name'), {
        confirmButtonText: this.$t('text.save').toUpperCase(),
        cancelButtonText: this.$t('text.cancel').toUpperCase(),
        confirmButtonClass: 'save-btn',
        cancelButtonClass: 'cancel-btn ml-20 right-float',
        customClass: 'pb-20',
        beforeClose: function(action, instance, done) {
          if (action === 'confirm') {
            this.confirmButtonText = vm.$t('text.save').toUpperCase() + '...'
            vm.save(instance.inputValue, done)
          } else {
            done()
          }
        }
      })
    },
    save(themeName, done = null) {
      this.loading = true
      ApiService.SaveCustomTheme({
        Id: this.Id,
        ThemeName: themeName,
        Value: JSON.stringify({
          colors: {
            ...this.form,
            title: themeName
          },
          font: '',
          logo: '',
          loginBg: ''
        })
      })
        .then(response => {
          this.loading = false
          if (done) {
            done()
          }
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
            this.handleUpdateColor(themeName)
            this.closeDialog()
            this.$parent.getData()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    handleUpdateColor(themeName) {
      if (
        this.Id &&
        this.Id === this.$store.state.customization.colorObjForNewDesign.id
      ) {
        this.$store.dispatch('customization/applyColorForNewDesign', {
          ...this.form,
          title: themeName
        })
        this.$store.dispatch('customization/applyTopNavBg', {
          bg: this.$store.state.customization.topNavBg,
          opacity: this.$store.state.customization.topNavBgOpacity
        })
        this.$store.dispatch('customization/applyMenuBg', {
          bg: this.$store.state.customization.menuBg,
          opacity: this.$store.state.customization.menuBgOpacity
        })
        this.$store.dispatch('customization/applyMainContentBg', {
          bg: this.$store.state.customization.mainContentBg,
          opacity: this.$store.state.customization.mainContentBgOpacity
        })
      }
    }
  }
}
</script>
